
import { Component, Vue } from 'vue-property-decorator';

import axios, { AxiosResponse } from 'axios';

import { ApplicationModule } from '@/lib/models';

@Component
export default class ApplicationModules extends Vue {
  private applicationModules: ApplicationModule[] = [];

  private async created(): Promise<void> {
    this.getApplicationModules()
      .then((response) => {
        this.applicationModules = response.data.data;
      }).catch((error) => {
        const message: string = error.response?.data?.message ?? error.message;
        this.$bvModal.msgBoxOk(message, {
          title: 'Error Getting Application Modules',
          okVariant: 'danger',
          centered: true,
        });
      });
  }

  private async getApplicationModules(): Promise<AxiosResponse<any>> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/applicationmodules/dashboard?sort=name`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}
